class LWFullImage extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    static get observedAttributes() {
        return ['src', 'opacity', 'color'];
    }

    attributeChangedCallback() {
        this.render();
    }

    render() {
        const src = this.getAttribute('src') || '';
        const opacity = this.getAttribute('opacity') || '1';
        const color = this.getAttribute('color') || 'transparent';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                /* We dwingen de host om de padding van de .panel te negeren */
                position: absolute;
                /* Inset trekt de randen naar de uiterste hoeken van de .panel */
                top: -80px;
                left: -100px;
                right: -100px;
                bottom: -80px;
                
                z-index: -1;
                pointer-events: none;
                overflow: hidden;
            }

            .background {
                width: 100%;
                height: 100%;
                background-color: ${color};
                background-image: url('${src}');
                /* Center zorgt dat het midden van de foto ALTIJD in het midden van de kolom staat */
                background-position: center center;
                background-size: cover;
                background-repeat: no-repeat;
                background-blend-mode: multiply; 
                opacity: ${opacity};
            }

            @media (max-width: 767px) {
                :host {
                    /* Match de mobiele padding van je LWMagazine (60px 40px) */
                    top: -60px;
                    left: -40px;
                    right: -40px;
                    bottom: -60px;
                }
            }
        </style>
        <div class="background"></div>
        `;
    }
}

customElements.define('lw-fullimage', LWFullImage);